import moment from "moment";
import React from "react";
import { DayPicker } from "react-day-picker";

export const MonthCard = ({
  month,
  hiddenDays,
  startingCalendarDay,
  selectedDaysState,
  setSelectedDaysState,
  modifiers,
  modifiersStyles,
  modifiersClassNames,
}) => {
  // Custom caption to hide the months arrows and only show the month name
  const customCaption = () => {
    return <h2 className="month-title">{moment(month).format("MMM YYYY")}</h2>;
  };

  return (
    <div className="month-card">
      <DayPicker
        month={moment(month).toDate()}
        hidden={hiddenDays}
        disableNavigation
        showOutsideDays
        mode="range"
        styles={{ cell: { width: "fit-content" } }}
        components={{ Caption: customCaption }}
        //   Selected are modifiers corresponding to the current selected day ranges
        selected={selectedDaysState}
        onSelect={setSelectedDaysState}
        weekStartsOn={startingCalendarDay}
        //   Modifiers correspond to the existing events (see annual planner helpers)
        modifiers={modifiers}
        modifiersStyles={modifiersStyles}
        modifiersClassNames={modifiersClassNames}
      />
    </div>
  );
};
